import { decorate, observable, computed, autorun } from "mobx";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import { Moment } from "moment";
import moment from "moment";
// @ts-ignore
import BaumkuchenVariation1 from "../../img/baumkuchen-form/baumkuchen-variation1.jpg";
// @ts-ignore
import BaumkuchenVariation2 from "../../img/baumkuchen-form/baumkuchen-variation2.jpg";
// @ts-ignore
import BaumkuchenVariation4 from "../../img/baumkuchen-form/baumkuchen-variation4.jpg";
// @ts-ignore
import BaumkuchenVariation5 from "../../img/baumkuchen-form/baumkuchen-variation5.jpg";
// @ts-ignore
import BaumkuchenVariation8 from "../../img/baumkuchen-form/baumkuchen-variation8.jpg";
// @ts-ignore
import BaumkuchenVariation10 from "../../img/baumkuchen-form/baumkuchen-variation10.jpg";
// @ts-ignore
import BaumkuchenVariation20 from "../../img/baumkuchen-form/baumkuchen-variation20.jpg";
// @ts-ignore
import CharmVariation1 from "../../img/charm-form/charm-variation1.jpg";
// @ts-ignore
import CharmVariation2 from "../../img/charm-form/charm-variation2.jpg";
// @ts-ignore
import CharmVariation3 from "../../img/charm-form/charm-variation3.jpg";
// @ts-ignore
import CharmVariation4 from "../../img/charm-form/charm-variation4.jpg";

export const plans = [
  "3000プラン",
  "4000プラン",
  "5000プラン",
  "8000プラン",
  "12000プラン",
  "16000プラン",
  "20000プラン",
  "30000プラン",
] as const;

export const newPlans = [
  "3350プラン",
  "4350プラン",
  "5350プラン",
  "9350プラン",
  "11350プラン",
  "21350プラン",
] as const;

const unifiedPlans = [...plans, ...newPlans];

export const plan2price = (plan: Plan): number => {
  switch (plan) {
    case "3000プラン":
      return 3000;
    case "3350プラン":
      return 3350;
    case "4000プラン":
      return 4000;
    case "4350プラン":
      return 4350;
    case "5000プラン":
      return 5000;
    case "5350プラン":
      return 5350;
    case "8000プラン":
      return 8000;
    case "9350プラン":
      return 9350;
    case "11350プラン":
      return 11350;
    case "12000プラン":
      return 12000;
    case "16000プラン":
      return 16000;
    case "20000プラン":
      return 20000;
    case "21350プラン":
      return 21350;
    case "30000プラン":
      return 30000;
  }
};

type Plan = (typeof unifiedPlans)[number];

export const isPlan = (plan: any): plan is Plan => unifiedPlans.includes(plan);

export const charms = [
  {
    name: "めでタイすだち",
    price: 360,
    listPrice: 360,
    src: CharmVariation1,
    code: "charm-1",
  },
  {
    name: "今治タオル",
    price: 560,
    listPrice: 560,
    src: CharmVariation2,
    code: "charm-2",
  },
  {
    name: "温泉紅茶",
    price: 760,
    listPrice: 760,
    src: CharmVariation4,
    code: "charm-3",
  },
  {
    name: "縁起物を入れない",
    price: 0,
    listPrice: 0,
    src: CharmVariation3,
    code: undefined,
  },
] as const;

export type Charm = (typeof charms)[number];

export const isCharm = (charm: any): charm is Charm => charms.includes(charm);

export const designs = [
  "S01",
  "P01",
  "P02",
  "P03",
  "P04",
  "P05",
  "P06",
  "P07",
  "P08",
  "P09",
  "P10",
  "P11",
  "P12",
  "P13",
] as const;

export type Design = (typeof designs)[number];

export const i18nSweetShort = (x: SweetCode) =>
  x === "PLAIN" ? "プレーン" : x;

export const i18nSweet = (x: SweetCode) => {
  if (x === "PLAIN") {
    return "プレーンタイプバームクーヘン";
  }
  const t = (() => {
    switch (x.split("-")[1]) {
      case "SP1":
        return "スーパーフードタイプ";
      case "GL1":
        return "金箔タイプ";
      default:
        return "";
    }
  })();
  return t + "バームクーヘン(" + x + ")";
};

export const sweets = [
  { code: "PLAIN", price: 1050, listPrice: 1500, src: BaumkuchenVariation1 },
  {
    code: "WH1-SP1-M1-H",
    price: 1400,
    listPrice: 2000,
    src: BaumkuchenVariation2,
  },
  {
    code: "CC1-SP1-M1-H",
    price: 1400,
    listPrice: 2000,
    src: BaumkuchenVariation4,
  },
  {
    code: "AM1-SP1-M1-H",
    price: 1680,
    listPrice: 2400,
    src: BaumkuchenVariation5,
  },
  {
    code: "WH1-GL1-M1-H",
    price: 1330,
    listPrice: 1900,
    src: BaumkuchenVariation10,
  },
  {
    code: "CC1-GL1-M1-H",
    price: 1330,
    listPrice: 1900,
    src: BaumkuchenVariation8,
  },
  {
    code: "AM1-GL1-M1-H",
    price: 1540,
    listPrice: 2200,
    src: BaumkuchenVariation20,
  },
] as const;

const findSweet = (code: string) => sweets.find((x) => x.code === code);
const findCharm = (name: string) => charms.find((x) => x.name === name);

export type Sweet = (typeof sweets)[number];
export type SweetCode = Sweet["code"];

export class Pattern {
  constructor(seed: any = {}) {
    this.amount = seed.amount || undefined;
    this.plan = seed.plan || undefined;
    // HACK: findCharmで必ず何かしら見つかると思い込んでる
    this.charm = seed.charm ? (findCharm(seed.charm) as Charm) : charms[0];
    this.design = seed.design || "S01";
    // 引き菓子が見つからなければ、プレーンタイプにもどす
    // NOTE: 廃盤があるので、廃盤になったのを選択してた場合は、プレーンにfallbackする
    // 仕様合意済み。
    this.sweet = seed.sweet ? findSweet(seed.sweet) || sweets[0] : sweets[0];
    this.comment = seed.comment || "";
  }

  amount?: number;
  plan?: Plan;
  charm: Charm;
  design: Design;
  sweet: Sweet;
  comment: string;

  toJSON = () => ({
    amount: this.amount === undefined ? null : this.amount,
    plan: this.plan === undefined ? null : this.plan,
    charm: this.charm.name,
    design: this.design,
    sweet: this.sweet.code,
    comment: this.comment,
  });
}

decorate(Pattern, {
  amount: observable.ref,
  plan: observable.ref,
  charm: observable.ref,
  design: observable.ref,
  sweet: observable.ref,
  comment: observable.ref,
});

export const referralOptions = [
  "選択してください",
  "紹介なし",
  "友人・知人",
  "プランナー・アドバイザー",
  "紹介コード",
  "その他",
] as const;

export const referrals = [
  "オーセモーション・プロダクツ",
  "PMA",
  "その他",
] as const;

export const userTypes = ["新郎", "新婦"] as const;

export type ReferralOption = (typeof referralOptions)[number];
export type Referral = (typeof referrals)[number];

export type UserType = (typeof userTypes)[number];

export const isReferralOption = (
  referralOption: any
): referralOption is ReferralOption => referralOptions.includes(referralOption);

export const isReferral = (x: any): x is Referral => referrals.includes(x);

export const isUserType = (userType: any): userType is UserType =>
  userTypes.includes(userType);

export const cardDesigns = [
  "不要",
  "AP01",
  "AP02",
  "AP03",
  "AP04",
  "AP05",
  "AP06",
  "AP07",
  "AP08",
] as const;

export type CardDesign = (typeof cardDesigns)[number];

export const deliverySchedules = [
  "挙式3日前までに着",
  "挙式5日前までに着",
  "挙式7日前までに着",
] as const;

export type DeliverySchedule = (typeof deliverySchedules)[number];

export const isDeliverySchedule = (
  deliverySchedule: any
): deliverySchedule is DeliverySchedule =>
  deliverySchedules.includes(deliverySchedule);

export const deliveryDestinations = ["式場", "ご自宅"] as const;

export type DeliveryDestination = (typeof deliveryDestinations)[number];

export const isDeliveryDestination = (
  deliveryDestination: any
): deliveryDestination is DeliveryDestination =>
  deliveryDestinations.includes(deliveryDestination);

// https://stackoverflow.com/a/1349426
const genId = (() => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  return (length: number) =>
    Array.from({ length }).map(() =>
      characters.charAt(Math.floor(Math.random() * characters.length))
    );
})();

export const buildEmail = (username: string) =>
  `support+${username}@postal.gift`;

const getDefaultAmpFlag = () => window.location.href.indexOf("_amp") !== -1;

const getDefaultPmaFlag = () => window.location.href.indexOf("_pma") !== -1;

const getPap = () => localStorage.getItem("gift.postal.pap");

export class ContactViewStore {
  constructor() {
    this.dispose = autorun(() => {
      if (this.usePatterns && this.patterns.length === 1) {
        this.addPattern();
      }
    });
  }

  dispose: () => void;

  initialized = false;

  internal = window.location.href.indexOf("_internal") !== -1;

  amp = getDefaultAmpFlag();

  pma = getDefaultPmaFlag();

  weddingDate?: Moment;

  mainName = "";
  subName = "";
  mainUserType?: UserType | null;

  get groomName() {
    return this.mainUserType === "新郎" ? this.mainName : this.subName;
  }

  get brideName() {
    return this.mainUserType === "新婦" ? this.mainName : this.subName;
  }

  get subUserType() {
    return this.mainUserType === "新婦" ? "新郎" : "新婦";
  }

  nameRoman = "";

  phoneNumber = "";
  phoneNumber2 = "";

  useWeddingGift = true;
  usePrivateGift = false;

  get safePhoneNumber() {
    return this.phoneNumber
      .replace(
        // 全角を半角に変換する
        /[０-９]/g,
        (s) => String.fromCharCode(s.charCodeAt(0) - 65248)
      )
      .replace(
        // 数字以外を削除する
        /\D/g,
        ""
      );
  }

  get safePhoneNumber2() {
    return this.phoneNumber2
      .replace(
        // 全角を半角に変換する
        /[０-９]/g,
        (s) => String.fromCharCode(s.charCodeAt(0) - 65248)
      )
      .replace(
        // 数字以外を削除する
        /\D/g,
        ""
      );
  }

  email = "";
  email2 = "";

  preferSMS = false;

  postalCode = "";

  address = "";

  usePatterns = false;

  patterns = [new Pattern()];

  comment = "";

  referralOption: ReferralOption =
    this.amp || this.pma
      ? "プランナー・アドバイザー"
      : getPap()
      ? "紹介コード"
      : "選択してください";

  referral?: Referral = (() => {
    if (this.amp) return "オーセモーション・プロダクツ";
    if (this.pma) return "PMA";
    return undefined;
  })();

  referralStaffName = getPap() || "";

  directDelivery = true;

  deliveryToNonHome = false;
  deliveryToOther = "";
  changeDeliveryDateToGuest = false;
  deliveryDateToGuest?: Moment | null;
  changeArrivalDateToOther = false;
  arrivalDateToOther?: Moment | null;
  deliveryCardToNonHome = false;
  deliveryCardTo = "";
  customizeLetterMessage = false;
  letterMessage: string | null = null;

  get getLetterMessage() {
    return this.letterMessage == null
      ? "この度は二人の門出をお祝いいただきまして\n" +
          "誠にありがとうございました\n" +
          "皆様と共に迎えた1日は私たちにとって\n" +
          "忘れることのできない大切な記念日となりました\n" +
          "\n" +
          "二人の感謝の気持ちの記念品をどうぞお受け取りください\n" +
          "今後とも末永いお付き合いをよろしくお願い致します\n" +
          "\n" +
          (this.groomName + "・" + this.brideName + "（旧姓　）\n") +
          (this.postalCode + "　" + this.address + "\n")
      : this.letterMessage;
  }

  cardDesign: CardDesign = "AP03";

  deliverySchedule: DeliverySchedule = "挙式3日前までに着";

  deliveryDestination: DeliveryDestination = "ご自宅";

  isOrdered = false;

  //
  // Methods
  //

  reload = async () => {
    const currentUser = firebase.auth().currentUser;
    if (currentUser === null) return;

    return firebase
      .database()
      .ref(`orders/${currentUser.uid}`)
      .once("value")
      .then((snapshot) => {
        const val = snapshot.val();
        if (!val) return;

        this.weddingDate = val.weddingDate
          ? moment(val.weddingDate)
          : undefined;
        this.mainName = val.mainName || val.brideName || "";
        this.mainUserType = val.mainUserType || (val.brideName ? "新婦" : null);
        this.subName = val.subName || val.groomName || "";
        this.nameRoman = val.nameRoman || "";
        this.phoneNumber = val.phoneNumber === "-" ? "" : val.phoneNumber || "";
        this.phoneNumber2 =
          val.phoneNumber2 === "-" ? "" : val.phoneNumber2 || "";
        this.useWeddingGift =
          val.useWeddingGift != null ? val.useWeddingGift : true;
        this.usePrivateGift =
          val.usePrivateGift != null ? val.usePrivateGift : false;
        this.email = val.email || "";
        this.email2 = val.email2 || "";
        this.preferSMS = val.preferSMS || false;
        this.postalCode = val.postalCode || "";
        this.address = val.address || "";
        this.usePatterns = val.usePatterns || false;
        const safePatterns = val.patterns
          ? val.patterns.filter((p: any) => p)
          : [];
        this.patterns =
          safePatterns.length > 0
            ? safePatterns.map((p: any) => new Pattern(p))
            : [new Pattern()];
        this.comment = val.comment || "";
        this.amp = val.amp || getDefaultAmpFlag();
        this.pma = val.pma || getDefaultPmaFlag();
        this.referralOption =
          // NOTE: マイグレーション用のロジック
          val.referralOption ||
          (val.referred === true
            ? "プランナー・アドバイザー"
            : this.amp || this.pma
            ? "プランナー・アドバイザー"
            : getPap()
            ? "紹介コード"
            : "選択してください");
        this.referral = (() => {
          if (val.referral) return val.referral;
          if (getDefaultAmpFlag()) return "オーセモーション・プロダクツ";
          if (getDefaultPmaFlag()) return "PMA";
          return undefined;
        })();
        this.referralStaffName = val.referralStaffName || getPap() || "";
        this.directDelivery =
          // NOTE: マイグレーション用のロジック
          val.directDeliveryVersion === 2
            ? val.directDelivery === undefined
              ? true
              : val.directDelivery
            : true;
        this.cardDesign = val.cardDesign || "AP03";
        this.deliverySchedule = val.deliverySchedule || "挙式3日前までに着";
        this.deliveryDestination = val.deliveryDestination || "式場";

        this.deliveryToNonHome = val.deliveryToNonHome || false;
        this.deliveryToOther = val.deliveryToOther || "";
        this.changeDeliveryDateToGuest = val.changeDeliveryDateToGuest || false;
        this.deliveryDateToGuest = val.deliveryDateToGuest
          ? moment(val.deliveryDateToGuest)
          : null;
        this.changeArrivalDateToOther = val.changeArrivalDateToOther || false;
        this.arrivalDateToOther = val.arrivalDateToOther
          ? moment(val.arrivalDateToOther)
          : null;
        this.deliveryCardToNonHome = val.deliveryCardToNonHome || false;
        this.deliveryCardTo = val.deliveryCardTo || "";
        this.customizeLetterMessage = val.customizeLetterMessage || false;
        this.letterMessage = val.letterMessage || null;
        this.isOrdered = val.isOrdered || false;
      });
  };

  addPattern = () => {
    this.patterns.push(new Pattern());
  };

  toJSON = () => {
    console.log("tojson", this);
    return {
      amp: this.amp,
      pma: this.pma,
      weddingDate:
        this.weddingDate === undefined ? null : this.weddingDate.toISOString(),
      groomName: this.groomName,
      brideName: this.brideName,
      mainName: this.mainName,
      subName: this.subName,
      mainUserType: this.mainUserType,
      nameRoman: this.nameRoman,
      phoneNumber: this.phoneNumber,
      phoneNumber2: this.phoneNumber2,
      useWeddingGift: this.useWeddingGift,
      usePrivateGift: this.usePrivateGift,
      email: this.email,
      email2: this.email2,
      preferSMS: this.preferSMS,
      postalCode: this.postalCode,
      address: this.address,
      usePatterns: this.usePatterns,
      patterns: this.patterns.map((p) => p.toJSON()),
      comment: this.comment,
      referralOption: this.referralOption,
      referral: this.referral || null,
      referralStaffName: this.referralStaffName,
      directDelivery: this.directDelivery,
      directDeliveryVersion: 2,
      cardDesign: this.cardDesign,
      deliverySchedule: this.deliverySchedule,
      deliveryDestination: this.deliveryDestination,
      deliveryToNonHome: this.deliveryToNonHome,
      deliveryToOther: this.deliveryToOther,
      changeDeliveryDateToGuest: this.changeDeliveryDateToGuest,
      deliveryDateToGuest: this.deliveryDateToGuest
        ? this.deliveryDateToGuest.toISOString()
        : null,
      changeArrivalDateToOther: this.changeArrivalDateToOther,
      arrivalDateToOther: this.arrivalDateToOther
        ? this.arrivalDateToOther.toISOString()
        : null,
      deliveryCardToNonHome: this.deliveryCardToNonHome,
      deliveryCardTo: this.deliveryCardTo,
      customizeLetterMessage: this.customizeLetterMessage,
      letterMessage: this.letterMessage,
      isOrdered: this.isOrdered,
    };
  };

  toRequest = (orderType: "inquiry" | "order" | "draft" | "cancel") => {
    const currentUser = firebase.auth().currentUser;
    console.log("toRequest");
    const json: any = {
      amp: this.amp,
      pma: this.pma,
      emailAddress: this.email,
      sms: this.safePhoneNumber,
      phoneNumber2: this.safePhoneNumber2,
      emailAddress2: this.email2,
      orderType,
      comment: this.comment,
      username: localStorage.getItem("gift.postal.username"),
      password: localStorage.getItem("gift.postal.password"),
      mainName: this.mainName,
      subName: this.subName,
      mainUserType: this.mainUserType,
      subUserType: this.subUserType,
      brideName: this.brideName,
      groomName: this.groomName,
      nameRoman: this.nameRoman,
      weddingDate: this.weddingDate && this.weddingDate.format("YYYY/MM/DD"),
      zipcode: this.postalCode,
      address: this.address,
      introduction: this.referralOption,
      referral:
        this.referralOption == "プランナー・アドバイザー"
          ? this.referral
          : undefined,
      referralStaffName: this.referralStaffName,
      userId: currentUser && currentUser.uid,
      individualDelivery: this.directDelivery,
      cardDesign: this.cardDesign,
      arrivalDate: this.deliverySchedule,
      deliveryDestination: this.deliveryDestination,
      dryrun: this.internal,
      useWeddingGift: this.useWeddingGift,
      usePrivateGift: this.usePrivateGift,
      deliveryToNonHome: this.deliveryToNonHome,
      deliveryToOther: this.deliveryToOther,
      changeDeliveryDateToGuest: this.changeDeliveryDateToGuest,
      deliveryDateToGuest:
        this.deliveryDateToGuest &&
        this.deliveryDateToGuest.format("YYYY/MM/DD"),
      changeArrivalDateToOther: this.changeArrivalDateToOther,
      arrivalDateToOther:
        this.arrivalDateToOther && this.arrivalDateToOther.format("YYYY/MM/DD"),
      deliveryCardToNonHome: this.deliveryCardToNonHome,
      deliveryCardTo: this.deliveryCardTo,
      customizeLetterMessage: this.customizeLetterMessage,
      letterMessage: this.getLetterMessage,
      preferSMS: this.preferSMS,
    };
    console.log(json);

    this.availablePatterns.forEach((p, i) => {
      json[`num${i + 1}`] = p.amount;
      json[`plan${i + 1}`] = p.plan;
      json[`planCode${i + 1}`] = p.plan && `selects-${plan2price(p.plan)}`;
      json[`charm${i + 1}`] = p.charm.name;
      json[`charmCode${i + 1}`] = p.charm.code;
      json[`design${i + 1}`] = p.design;
      json[`designCode${i + 1}`] =
        p.design && `selects-noshi-${p.design.toLowerCase()}`;
      json[`sweet${i + 1}`] = p.sweet.code;
      json[`sweetCode${i + 1}`] = p.sweet && `B-${p.sweet.code}`;
      json[`comment${i + 1}`] = p.comment;
    });

    return json;
  };

  persist = () => {
    const currentUser = firebase.auth().currentUser;
    if (currentUser === null) return Promise.reject();

    console.log("persist");
    return firebase
      .database()
      .ref(`orders/${currentUser.uid}`)
      .set(this.toJSON());
  };

  signInAnonymouslyIfNeeded = () => {
    const currentUser = firebase.auth().currentUser;
    if (currentUser !== null) return Promise.resolve();
    return firebase
      .auth()
      .signInAnonymously()
      .then((_) => undefined);
  };

  linkCredential = () => {
    const currentUser = firebase.auth().currentUser;
    if (currentUser === null) return Promise.reject();
    if (currentUser.email !== null) return Promise.resolve();

    // Gen random strings.
    const username = genId(8).join("");
    const password = genId(8).join("");

    // Persist the set
    localStorage.setItem("gift.postal.username", username);
    localStorage.setItem("gift.postal.password", password);

    return currentUser
      .linkWithCredential(
        firebase.auth.EmailAuthProvider.credential(
          buildEmail(username),
          password
        )
      )
      .then((_) => undefined);
  };

  //
  // Estimate
  //
  get estimate() {
    return {
      plans: unifiedPlans.map((plan) => ({
        plan,
        amount: this.availablePatterns.reduce(
          (sum, pattern) =>
            sum + (pattern.plan === plan ? pattern.amount || 0 : 0),
          0
        ),
      })),
      sweets: sweets.map((sweet) => ({
        sweet: sweet,
        amount: this.availablePatterns.reduce(
          (sum, pattern) =>
            sum + (pattern.sweet === sweet ? pattern.amount || 0 : 0),
          0
        ),
      })),
      charms: charms.map((charm) => ({
        charm: charm,
        amount: this.availablePatterns.reduce(
          (sum, pattern) =>
            sum + (pattern.charm === charm ? pattern.amount || 0 : 0),
          0
        ),
      })),
    };
  }

  get plainBaumDiscountable() {
    return (
      this.availablePatterns.reduce(
        (sum, pattern) =>
          sum + (pattern.sweet.code === "PLAIN" ? pattern.amount || 0 : 0),
        0
      ) >= 10
    );
  }

  get decoBaumDiscountable() {
    return (
      this.availablePatterns.reduce(
        (sum, pattern) =>
          sum + (pattern.sweet.code !== "PLAIN" ? pattern.amount || 0 : 0),
        0
      ) >= 20
    );
  }

  //
  // Validations
  //

  get hasBasicContactInfo() {
    return (
      this.weddingDate !== undefined &&
      this.mainName !== "" &&
      this.mainUserType !== undefined &&
      this.subName !== ""
    );
  }

  get hasValidEmail() {
    return (
      this.preferSMS ||
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.email
      )
    );
  }

  get hasAdvancedContactInfo() {
    return (
      this.hasBasicContactInfo &&
      (this.internal || this.safePhoneNumber !== "") &&
      (this.internal || this.address !== "") &&
      (this.preferSMS || this.email !== "")
    );
  }

  get hasAllInfo() {
    return (
      this.hasAdvancedContactInfo &&
      (this.internal ||
        (this.availablePatterns.length > 0 &&
          this.availablePatterns[0].amount !== undefined &&
          this.availablePatterns[0].amount !== null &&
          this.availablePatterns[0].plan !== undefined &&
          this.availablePatterns[0].plan !== null))
    );
  }

  get availablePatterns() {
    return this.usePatterns ? this.patterns : this.patterns.slice(0, 1);
  }
}

decorate(ContactViewStore, {
  initialized: observable.ref,
  weddingDate: observable.ref,
  mainName: observable.ref,
  mainUserType: observable.ref,
  subName: observable.ref,
  nameRoman: observable.ref,
  useWeddingGift: observable.ref,
  usePrivateGift: observable.ref,
  phoneNumber: observable.ref,
  phoneNumber2: observable.ref,
  safePhoneNumber: computed,
  safePhoneNumber2: computed,
  email: observable.ref,
  email2: observable.ref,
  preferSMS: observable.ref,
  postalCode: observable.ref,
  address: observable.ref,
  usePatterns: observable.ref,
  patterns: observable.shallow,
  estimate: computed,
  plainBaumDiscountable: computed,
  decoBaumDiscountable: computed,
  hasBasicContactInfo: computed,
  hasValidEmail: computed,
  hasAdvancedContactInfo: computed,
  hasAllInfo: computed,
  availablePatterns: computed,
  comment: observable.ref,
  referralOption: observable.ref,
  referral: observable.ref,
  referralStaffName: observable.ref,
  directDelivery: observable.ref,
  deliveryToOther: observable.ref,
  deliveryToNonHome: observable.ref,
  changeDeliveryDateToGuest: observable.ref,
  deliveryDateToGuest: observable.ref,
  changeArrivalDateToOther: observable.ref,
  arrivalDateToOther: observable.ref,
  deliveryCardTo: observable.ref,
  deliveryCardToNonHome: observable.ref,
  customizeLetterMessage: observable.ref,
  letterMessage: observable.ref,
  getLetterMessage: computed,
  cardDesign: observable.ref,
  deliverySchedule: observable.ref,
  deliveryDestination: observable.ref,
  isOrdered: observable.ref,
});
